import React from 'react';
import { designSystem } from '@yola/ws-ui';
import PropTypes from 'prop-types';

const { Slider, SliderPattern } = designSystem;

const glyphsMap = {
  animation_speed: 'animation-speed',
  border_width: 'border-thickness',
  items_count: 'grid',
  media_column_width: 'arrow-w',
  overlay_opacity: 'overlay',
  space_between: 'padding-horizontal',
  whitespace_bottom: 'padding-bottom',
  whitespace_top: 'padding-top',
};

const getGlyph = (optionId) => glyphsMap[optionId] || '';

function BlockSettingsSlider({
  itemId,
  min = 0,
  max = 100,
  step = 1,
  value = 0,
  onChange = Function.prototype,
  onAfterChange = Function.prototype,
  ...otherProps
}) {
  const iconGlyph = getGlyph(itemId);

  if (iconGlyph) {
    return (
      <SliderPattern
        iconGlyph={iconGlyph}
        isValueEditable={false}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
        onAfterChange={onAfterChange}
        {...otherProps}
      />
    );
  }

  return (
    <Slider
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={onChange}
      onAfterChange={onAfterChange}
      {...otherProps}
    />
  );
}

BlockSettingsSlider.propTypes = {
  itemId: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  valueLabelDisplay: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onAfterChange: PropTypes.func,
};

export default BlockSettingsSlider;
